import { mapActions } from "vuex";

export default {
    name: "archivme",
    data() {
        return {
            show:{
                NotOver_Export: false,
                NotOver_Query: false
            },
            form: {
                orderId: null,// 订单id
                startCityName: null,// 始发地
                destCityName: null,// 目的地
                createTime: null,
                beginTime:null,
                endTime:null,
                pageNumber: 1,
                pageSize: 10,
                /* source: 2, */
            },
            vehicleTypeList: [
                {
                    value: null,
                    label: "全部"
                },
                {
                    value: 1,
                    label: "厢式"
                },
                {
                    value: 2,
                    label: "平板"
                },
                {
                    value: 3,
                    label: "高栏"
                },
                {
                    value: 4,
                    label: "特种运输"
                },
                {
                    value: 5,
                    label: "封闭式一体货车/客车"
                },
                {
                    value: 6,
                    label: "冷藏车"
                },
                {
                    value: 7,
                    label: "食品单温冷藏车"
                },
                {
                    value: 8,
                    label: "食品双温冷藏车"
                },
                {
                    value: 9,
                    label: "医药单温冷藏车"
                },
                {
                    value: 10,
                    label: "医药双温冷藏车"
                }
            ],
            vehicleLengthList: [
                {
                    value: 1.8,
                    label: "1.8米"
                },
                {
                    value: 2.7,
                    label: "2.7米"
                },
                {
                    value: 3.5,
                    label: "3.5米"
                },
                {
                    value: 4.2,
                    label: "4.2米"
                },
                {
                    value: 5.2,
                    label: "5.2米"
                },
                {
                    value: 6.2,
                    label: "6.2米"
                },
                {
                    value: 7.6,
                    label: "7.6米"
                },
                {
                    value: 9.6,
                    label: "9.6米"
                },
                {
                    value: 13.5,
                    label: "13.5米"
                },
                {
                    value: 15,
                    label: "15米"
                },
                {
                    value: 16,
                    label: "16米"
                },
                {
                    value: 17.5,
                    label: "17.5米"
                }
            ],
            pageLoading: false,
            pageData: [],
            pageInitInfo: {
                pageSizes: [10, 20, 30, 40, 50, 100],
                pageSize: 10,
                pageNumber: 1,
                total: 0
            },
            tableColunm: [// 列表
                {
                    prop: 'orderId',
                    label: '订单号',
                    width: 200
                },
                {
                    prop: 'transportFee',
                    label: '运费(元)',
                    width: 200, 
                    formatter: function (row, column) {
                        return row.transportFee;
                    }
                },

                {
                    prop: 'loadWaitFee',//运费，确认订单金额是不是就是运费
                    label: '装车等待费（元）',
                    width: 140,
                    formatter: function (row, column) {
                         return row.loadWaitFee ;
                    }

                },
                {
                    prop: 'unLoadWaitFee',//运费，确认订单金额是不是就是运费
                    label: '卸车等待费（元）',
                    width: 140,
                    formatter: function (row, column) {
                        return row.unLoadWaitFee ;
                    }

                },
                {
                    prop: 'emptyFee',//运费，确认订单金额是不是就是运费
                    label: '空置费（元）',
                    width: 140,
                    formatter: function (row, column) {
                        return row.emptyFee ;
                    }
                },
                {
                    prop: 'adjustDeductFee',//运费，确认订单金额是不是就是运费
                    label: '调整补扣费（元）',
                    width: 140,
                    formatter: function (row, column) {
                        return row.adjustDeductFee ;
                    }
                },
                {
                    prop: 'byCarLaterFee',//运费，确认订单金额是不是就是运费
                    label: '靠卡晚点（元）',
                    width: 140,
                    formatter: function (row, column) {
                        return row.byCarLaterFee ;
                    }
                },
                {
                    prop: 'ponchosFee',//运费，确认订单金额是不是就是运费
                    label: '雨布费（元）',
                    width: 140,
                    formatter: function (row, column) {
                        return row.ponchosFee ;
                    }
                },
                {
                    prop: 'warehouseUnLoadFee',//运费，确认订单金额是不是就是运费
                    label: '仓库卸货费（元）',
                    width: 140,
                    formatter: function (row, column) {
                        return row.warehouseUnLoadFee ;
                    }
                },
                {
                    prop: 'runTimeoutFee',//运费，确认订单金额是不是就是运费
                    label: '运行超时（元）',
                    width: 140,
                    formatter: function (row, column) {
                        return row.runTimeoutFee ;
                    }
                },
                {
                    prop: 'otherFee',
                    label: '其他费用（元）',
                    width: 200,
                    formatter: function (row, column) {
                        return row.otherFee ;
                    }
                }, 
                {
                    prop: 'totalFee',
                    label: '合计应付(含税:元)',
                    width: 200, formatter: function (row, column) {
                        return row.totalFee;
                    }
                }, {
                    prop: 'startCityName',
                    label: '发货城市',
                    width: 200
                }, {
                    prop: 'destCityName',
                    label: '收货城市',
                    width: 200
                }, {
                    prop: 'cargoTypeName',
                    label: '货物信息',
                    width: 200
                }, {
                    prop: 'lineMileage',
                    label: '线路里程（KM）',
                    width: 200,
                    formatter: function (row, column) {
                        if (row.lineMileage) {
                            return row.lineMileage ;
                        }

                        return null;
                    }
                },
                {
                    prop: 'vehiclePlate',
                    label: '车牌',
                    width: 160
                },
                {
                    prop: 'vehicleType',
                    label: '车型/车长',
                    width: 160,
                    formatter: function (row, column) {
                        if (row.vehicleType) {
                            return row.vehicleType + '/' + row.vehicleLength +'m' ;
                        }

                        return null;
                    }
                },

                {
                    prop: 'actualCarrier',
                    label: '实际承运对象',
                    width: 160
                }, 
                {
                    label: '发车时间',
                    width: 260,
                    formatter: function (row, column) {
                        return <div><div>计划发车： {row.planDepartTime?row.planDepartTime:'-'} </div><div>实际发车： {row.actualDepartTime?row.actualDepartTime:'-'}</div>  </div> 
                    }
                },
                {
                    label: '到车时间',
                    width: 260,
                    formatter: function (row, column) {
                        return <div><div>计划到车： {row.planArriveTime?row.planArriveTime:'-'} </div><div>实际到车： {row.actualArriveTime?row.actualArriveTime:'-'}</div>  </div> 
                    }
                },
                {
                    prop: 'paymentDaysTime',
                    label: '账期归属时间',
                    width: 200
                },
                {
                    prop: 'contractSubjectName',
                    label: '签约主体',
                    width: 260
                }, 
                {
                    prop: 'orderBelongName',
                    label: '订单归属',
                    width: 260
                }, {
                    prop: 'waybillId',
                    label: '客户运单号',
                    width: 200
                }, {
                    prop: 'createTime',
                    label: '创建时间',
                    width: 160
                },
            ],
        }
    },
    methods: {
        ...mapActions([
            "getUnOrderListApi",
            "uploadFileApi",
            "downLoadFileApi",
        ]),
        onReset() {
            Object.assign(this.form, this.$options.data().form)
        },
        getHostUrl() {
            return location.protocol + "//" + location.host;
        },
        rowDblclick(row) {
            let param = {
                consignorState: 4,
                orderId: row.orderId,
                planDepartTm: row.planDepartTm,
                srcCityCode: row.srcCity
            }
            this.$emit("page", "订单管理列表", "ownerOrderManage", 200428);
            this.$store.commit("setUnsettledShipperOrder", param);
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 每页展示多少条数据改变事件
        sizeChange(val) {
            this.pageInitInfo.pageSize = val;
            this.pageInitInfo.pageNumber = 1;
            this.getPagaData();
        },
        // 页码改变事件
        currentChange(val) {
            // alert(val)
            this.pageInitInfo.pageNumber = val;
            this.getPagaData();
        },
        queryPage() {
            this.pageInitInfo.pageNumber = 1
            this.getPagaData();
        },
        getPagaData() {
            let param = Object.assign({},this.form)
            if (this.form.createTime) {
                param.beginTime = this.form.createTime[0];
                param.endTime = this.form.createTime[1];
            }
            param.pageNumber = this.pageInitInfo.pageNumber;
            param.pageSize = this.pageInitInfo.pageSize;
            delete param.createTime;
            this.getUnOrderListApi(param).then(res => {
                this.pageData = res.dataList;
                this.pageInitInfo.total = res.totalSize;

            }).catch(e => {

            });
        },
        exportShip() {
            let param = Object.assign({},this.form)
            if (this.form.createTime) {
                param.beginTime = this.form.createTime[0];
                param.endTime = this.form.createTime[1];
            }
            param.pageNumber = 1;
            param.pageSize = 10000;
            delete param.createTime;

            this.uploadFileApi(param).then(res => {
                // this.showDownload(this.getHostUrl()+"/saas/shipperOrderController/downLoadFile?objectName="+res.filePath)
                window.open(this.getHostUrl() + "/saas/shipperOrderController/downLoadFile?objectName=" + res.filePath)
            }).catch(e => {

            });
        },
        /* 显示下载弹窗 */
        showDownload(url) {
            let downloadbtn = `<a href="${url}">点击下载导出的Excel文件</a>`
            this.$alert(downloadbtn, '下载', {
                confirmButtonText: '取消',
                customClass: 'css-alert',
                dangerouslyUseHTMLString: true,
                callback: action => { }
            });
        },
        getTimeInit() {
            let start = new Date(new Date().getTime() - 15 * 24 * 60 * 60 * 1000);
            let end = new Date(new Date().getTime() + 15 * 24 * 60 * 60 * 1000);
            this.form.createTime = [start, end]
        }
    }, created: function () {
        this.getTimeInit();
        let menuInterval = setInterval(() => {
			let map = JSON.parse(sessionStorage.getItem('menuMap'))
			if (map) {
                clearInterval(menuInterval)
				let submenuList = map['NotOverBill'].split('-');
				submenuList.forEach((item, i) => {
					this.show[item] = true;
				});
			}
		}, 30);
        this.queryPage();
    }
};